import { render, staticRenderFns } from "./approval.vue?vue&type=template&id=f2701584&scoped=true"
import script from "./approval.vue?vue&type=script&lang=js"
export * from "./approval.vue?vue&type=script&lang=js"
import style0 from "./approval.vue?vue&type=style&index=0&id=f2701584&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2701584",
  null
  
)

export default component.exports